export default __webpack_public_path__ + "static/media/WStore_OnlineEntries.4f1a147d.png";